import { Button } from "@nextui-org/react";
import { startAuthorSync } from "@/app/author/actions/author";
import { IoMdSync } from "react-icons/io";

export default function Syncronization({
  authorId,
  isSyncing,
  lastSynchronizationDate,
  setIsSyncing,
  setModalMessage,
  setModalIsOpen,
  setModalIsError,
}) {
  const handleSync = async () => {
    setIsSyncing(true);
    const result = await startAuthorSync(authorId);

    if (!result.success) {
      setIsSyncing(false);
      setModalMessage("Error al iniciar la sincronización");
      setModalIsOpen(true);
      setModalIsError(true);
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-between border-t border-gray-200 p-5">
      <h2 className="text-xl font-bold mb-4">Sincronizar Publicaciones</h2>

      <Button
        color="primary"
        onPress={handleSync}
        disabled={isSyncing}
        className=""
      >
        Sincronizar <IoMdSync />
      </Button>

      <div className="text-gray-700 text-xs mt-2 text-center">
        <span className="font-bold">Última sincronización: </span>
        <span className="text-gray-500">
          {lastSynchronizationDate !== "Invalid Date"
            ? lastSynchronizationDate
            : "No hay sincronizaciones"}
        </span>
      </div>
    </div>
  );
}
